export default "__VITE_ASSET__DAHDpTro__"